'use strict';

(function () {
	angular.module('onboarding.carrier')
		.directive('cobCarrierProfileDocuments', cobCarrierProfileDocuments);

	cobCarrierProfileDocuments.$inject = [
		'$timeout', 'sessionService', 'Upload', 'subjectObserverMessagesService', 'observerService',
		'carrierRegistrationService', '$stateParams'
	];

	var $timeout,
		sessionService,
		ngFileUpload,
		subjectObserverMessagesService,
		observerService,
		carrierRegistrationService,
		$stateParams;
	var subjectMessages, observerMessages;

	var NOA_DOCUMENT_TYPE = 'Notice of Assigment (NOA)';

	function cobCarrierProfileDocuments(_$timeout_,
		_sessionService_,
		_ngFileUpload_,
		_subjectObserverMessagesService_,
		_observerService_,
		_carrierRegistrationService_,
		_$stateParams_) {
		$timeout = _$timeout_;
		sessionService = _sessionService_;
		ngFileUpload = _ngFileUpload_;
		subjectObserverMessagesService = _subjectObserverMessagesService_;
		observerService = _observerService_;
		carrierRegistrationService = _carrierRegistrationService_;
		$stateParams = _$stateParams_;

		return {
			restrict: 'E',
			scope: {},
			replace: true,
			templateUrl: '/app/carrier/profile/carrierProfileDocuments.html',
			link: linkFunction
		};
	}

	function linkFunction(scope) {

		activate();

		function activate() {
			subjectMessages = subjectObserverMessagesService.getSubjectMessages();
			observerMessages = subjectObserverMessagesService.getObserverMessages();
			scope.carrierId = $stateParams.carrierId;

			scope.m = {
				isBroker: sessionService.isBroker(),
				isAdmin: sessionService.isAuthorizedInternalAdmin(),
				disableUpload: true,
				displayNewRow: false,
				showCopiedMessage: false,
				documents: [],
				documentTypes: [
					'Interstate Authority Cert', 'State Authority Cert', 'Insurance Cert',
					'Vehicle Schedule', 'HazMat Cert', 'TWIC Card', 'C-TPAT Cert', NOA_DOCUMENT_TYPE, 'Other'
				],
				showDocumentNameError: false,
				showDocumentSharedModal: false,
				encryptedUrl: '',
				deleteDocument: {}
			};
			scope.editDocument = editDocument;
			scope.onUploadClick = onUploadClick;
			scope.onCancelUploadClick = onCancelUploadClick;
			scope.validateNewDocumentName = validateNewDocumentName;

			scope.onDocumentNameClick = onDocumentNameClick;
			scope.onDocumentTypeClick = onDocumentTypeClick;
			scope.onDescriptionClick = onDescriptionClick;
			scope.onFileUploadStart = onFileUploadStart;
			scope.onTrashClick = onTrashClick;
			scope.confirmDelete = confirmDelete;
			scope.cancelDelete = cancelDelete;
			scope.onForceGo = onForceGo;
			scope.setIsDirty = setIsDirty;
			scope.fileSizeHelper = fileSizeHelper;
			scope.goToTab = goToTab;
			scope.evaluateRows = evaluateRows;
			scope.selectedDocumentsCount = selectedDocumentsCount;
			scope.shareDocuments = shareDocuments;
			scope.copyToClipboard = copyToClipboard;
			scope.closeNoaAlreadyExistsModal = closeNoaAlreadyExistsModal;

			registerObserverHandlers();
			loadData();
			onDomainDataLoad();
			newDocumentClear();
			document.title = 'Profile-Documents';

			$timeout(function () {
				observerService.sendMessageToSubject(scope, subjectMessages.COB_SUBJECT_CARRIER_PROFILE_VIEW_LOAD);
			},
			100);
		}

		function loadData() {
			carrierRegistrationService.lookupCarrierDocuments(scope.carrierId)
				.then(function (response) {
					scope.m.disableUpload = true;
					newDocumentClear();

					if (response.data.documents) {
						scope.m.documents = response.data.documents;
					}
				});
		}

		function onDomainDataLoad() {
			var broker = sessionService.getBrokerBranding();
			if (broker && !scope.m.isBroker) {
				scope.brokerId = broker.brokerId;
				scope.m.brokerName = broker.brokerName;
				scope.m.documentsMessage = broker.documentsMessage;
				scope.m.documentsMessageDisabled = broker.documentsMessageDisabled;
			}
		}

		function registerObserverHandlers() {

			observerService.registerHandlers(scope,
				[
					{ message: observerMessages.COB_OBSERVER_DOMAIN_DATA_LOADED, handler: onDomainDataLoad },
					{ message: observerMessages.COB_OBSERVER_START_CHANGE_CARRIER_PROFILE_VIEW, handler: saveData },
					{ message: observerMessages.COB_OBSERVER_CARRIER_PROFILE_VIEW_IS_DIRTY, handler: setIsDirty },
					{ message: observerMessages.COB_OBSERVER_SET_PENDING_TAB, handler: setPendingTab }
				]);

			scope.$on('$destroy',
				function () {
					window.onbeforeunload = undefined;
				});

			scope.$on('$locationChangeStart',
				function (event) {
					if (scope.m.isDirty) {
						if (!scope.ux_requirement_hack_for_scrolling) {
							if (!confirm('You have unsaved data. If you leave this page any changes will be lost. Changes are saved using the Save buttons at the bottom of the page. Are you sure you want to leave the page?')) {
								event.preventDefault();
							}
						}
					}

					scope.ux_requirement_hack_for_scrolling = false;
				});
		}

		function validateNewDocumentName() {
			if (scope.m.newDocumentName) {
				scope.m.disableUpload = false;
				scope.m.showDocumentNameError = false;
			} else {
				scope.m.showDocumentNameError = true;
			}
		}

		function onUploadClick() {
			saveNewDocument(loadData);
		}

		function onCancelUploadClick() {
			newDocumentClear();
			scope.m.isDirty = false;
		}

		function newDocumentClear() {
			scope.m.newDocumentType = 'Interstate Authority Cert';
			scope.m.newDocumentDescription = '';
			scope.m.newDocumentName = '';
			scope.m.newDocumentBase64 = '';
			scope.m.displayNewRow = false;
			scope.m.showFileNameError = false;
			scope.m.disableUpload = true;
			scope.m.fileUploaderFile = undefined;
		}

		function onFileUploadStart() {
			if (scope.m.fileUploaderFile) {
				if (validateFile()) {
					setIsDirty();
					scope.m.displayNewRow = true;
					scope.m.newDocumentType = 'Interstate Authority Cert';
					ngFileUpload.base64DataUrl(scope.m.fileUploaderFile, false)
						.then(function (url) {
							scope.m.newDocumentBase64 = url.split(',')[1];
						});
					scope.m.fileUploaderFileError = '';
				} else {
					scope.m
						.fileUploaderFileError =
						'Only .doc, .docx, .gif, .jpeg, .jpg, .pdf, .png, .tif, .tiff, .xls, or .xlsx under 10mb allowed.';
				}
			}
		}

		function validateFile() {
			var validMimeTypes = [
				'application/pdf', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
				'application/msword', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
				'application/vnd.ms-excel', 'application/vnd.ms-word', 'image/tiff', 'image/png', 'image/jpeg',
				'image/gif'
			];

			if (validMimeTypes.indexOf(scope.m.fileUploaderFile.type) > -1) {
				if (scope.m.fileUploaderFile.size < 10485760) {
					return true;
				}
			}

			return false;
		}

		function fileSizeHelper(size) {
			if ((size ^ 0) === size) {
				if (size < 1024) {
					return size + 'B';
				} else if (size < 1048576) {
					return Math.round(size / 1024) + 'KB';
				} else if (size < 1073741824) {
					return Math.round(size / 1048576) + 'MB';
				}
			}
		}

		function setIsDirty() {
			scope.m.isDirty = true;

			window.onbeforeunload = function () {
				return 'You have unsaved data. If you leave this page any changes will be lost. Changes are saved using the Save buttons at the bottom of the page.';
			};
		}

		function saveData(callback) {
			if (!scope.m.isBroker) {

				carrierRegistrationService.visitedSection('documents', scope.carrierId, scope.brokerId)
					.then(function () {
						observerService.sendMessageToSubject(scope,
							subjectMessages.COB_SUBJECT_CARRIER_PROFILE_VIEW_STATUS,
							'documents');

						if (scope.m.displayNewRow) {
							validateNewDocumentName();
							if (!scope.m.showDocumentNameError)
								saveNewDocument(callback);
							else if (typeof (callback) === 'function') {
								scope.pendingCallback = callback;
								scope.showSectionMessage = true;
							}
						} else if (scope.m.isDirty) {
							angular.forEach(scope.m.documents,
								function (document) {
									if (document
										.documentTypeEdit ||
										document.documentNameEdit ||
										document.descriptionEdit) {
										editDocument(document, callback);

										return;
									}
								});
						} else {
							if (typeof (callback) === 'function') {
								callback();
							}
						}
					});
			} else {
				callback();
			}
		}

		function saveNewDocument(callback) {
			if (scope.m.documents.some(function(doc) { return doc.documentType === NOA_DOCUMENT_TYPE; }) &&
				scope.m.newDocumentType === NOA_DOCUMENT_TYPE) {
				scope.showNoaAlreadyExistsModal = true;

				return;
			}

			if (!scope.m.displayNewRow)
				return;
			if (scope.m.newDocumentBase64) {
				validateNewDocumentName();

				var fileName = scope.m.fileUploaderFile.name;
				var fileExtension = fileName.split('.').pop();
				fileName = fileName.substring(0, fileName.length - (fileExtension.length + 1)); //trim off extension

				setTimeout(function () {
					observerService.sendMessageToSubject(scope,
						subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_AJAX_WAITING);
				}, 1);

				carrierRegistrationService.insertCarrierDocument(fileName,
					fileExtension,
					scope.m.fileUploaderFile.type,
					scope.m.newDocumentBase64,
					scope.m.newDocumentDescription,
					scope.m.newDocumentType,
					scope.m.newDocumentName,
					scope.carrierId)
					.then(function () {
						scope.m.isDirty = false;

						// Clear fileUploaderFile so that trash cans become visible.
						scope.m.fileUploaderFile = undefined;
						if (typeof (callback) === 'function') {
							callback();
						}
					}).finally(function () {
						observerService
							.sendMessageToSubject(scope,
								subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_AJAX_DONE);
					});
			} else if (callback) {
				$timeout(function () {
					scope.ux_requirement_hack_for_scrolling = true;
					$('.profile-docs')
						.animate({
							scrollTop: $('#error-summary').offset().top
						},
						200);
					setIsDirty();
				},
				1);
			}
		}

		function editDocument(document, callback) {
			if (document.documentName) {
				document.showDocumentNameError = false;
				if (!document.documentStatus) {
					document.documentStatus = 'ACTIVE';
				}

				setTimeout(function () {
					observerService.sendMessageToSubject(scope,
						subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_AJAX_WAITING);
				}, 1);

				carrierRegistrationService.updateCarrierDocument(document.documentId,
					document.description,
					document.documentType,
					document.documentName,
					document.documentStatus,
					scope.carrierId)
					.then(function () {
						scope.m.isDirty = false;
						document.documentTypeEdit = false;
						document.documentNameEdit = false;
						document.descriptionEdit = false;

						if (typeof (callback) === 'function') {
							callback();
						}
					}).finally(function () {
						observerService
							.sendMessageToSubject(scope,
								subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_AJAX_DONE);
					});
			} else {
				document.showDocumentNameError = true;
				if (callback) {
					scope.showSectionMessage = true;
					scope.pendingCallback = callback;
					$timeout(function () {
						scope.ux_requirement_hack_for_scrolling = true;
						$('.profile-docs')
							.animate({
								scrollTop: $('#error-summary').offset().top
							},
							200);
					},
					1);
				}
			}
		}

		function onDocumentNameClick(document, event) {
			if (scope.m.isBroker)
				return;
			document.documentNameEdit = true;
			$timeout(function () {
				event.currentTarget.parentElement.children[1].children[0].focus();
			});
		}

		function onDocumentTypeClick(document, event) {
			if (scope.m.isBroker)
				return;
			document.documentTypeDirty = document.documentType;
			document.documentTypeEdit = true;

			$timeout(function () {
				event.currentTarget.parentElement.children[1].children[0].focus();
			});
		}

		function onDescriptionClick(document, event) {
			if (scope.m.isBroker)
				return;
			document.descriptionEdit = true;

			$timeout(function () {
				event.currentTarget.parentElement.children[1].children[0].focus();
			});
		}

		function onTrashClick(document) {
			if (scope.m.isBroker)
				return;
			scope.m.deleteDocument = document;
		}

		function confirmDelete() {
			scope.m.deleteDocument.documentStatus = 'INACTIVE';
			editDocument(scope.m.deleteDocument, loadData);
			scope.m.deleteDocument = {};
		}

		function cancelDelete() {
			scope.m.deleteDocument = {};
		}

		function goToTab(tab) {
			observerService.sendMessageToSubject(scope, subjectMessages.COB_SUBJECT_SET_PENDING_TAB, tab);
			observerService.sendMessageToSubject(scope,
				subjectMessages.COB_SUBJECT_START_CHANGE_CARRIER_PROFILE_VIEW,
				navigate);
		}

		function setPendingTab(tab) {
			scope.tab = tab;
		}

		function navigate() {
			observerService.sendMessageToSubject(scope,
				subjectMessages.COB_SUBJECT_FINISH_CHANGE_CARRIER_PROFILE_VIEW,
				scope.tab);
		}

		function onForceGo() {
			if (typeof (scope.pendingCallback) === 'function')
				scope.pendingCallback();
		}

		function evaluateRows() {
			if (scope.m.displayNewRow && scope.m.fileUploaderFile) {
				return true;
			} else {
				return false;
			}
		}

		function selectedDocumentsCount() {
			var count = 0;
			angular.forEach(scope.m.documents,
				function (doc) {
					count += doc.shared ? 1 : 0;
				});

			return count;
		}

		function shareDocuments() {
			var selectedDocs = [];
			if (selectedDocumentsCount() === 0) {
				angular.forEach(scope.m.documents,
					function (doc) {
						selectedDocs.push(doc.documentGuid);
					});
			} else {
				angular.forEach(scope.m.documents,
					function (doc) {
						if (doc.shared) {
							selectedDocs.push(doc.documentGuid);
						}
					});
			}

			carrierRegistrationService.shareDocuments(selectedDocs, scope.carrierId).then(function (response) {
				scope.m.showDocumentSharedModal = true;
				scope.m.encryptedUrl = response.data.url;
			});
		}

		function copyToClipboard() {
			scope.m.showCopiedMessage = true;
			var elem = document.getElementById('encryptedUrlText');
			var targetId = '_hiddenCopyText_';
			var isInput = elem.tagName === 'INPUT' || elem.tagName === 'TEXTAREA';
			var origSelectionStart, origSelectionEnd;
			if (isInput) {
				// can just use the original source element for the selection and copy
				target = elem;
				origSelectionStart = elem.selectionStart;
				origSelectionEnd = elem.selectionEnd;
			} else {
				// must use a temporary form element for the selection and copy
				target = document.getElementById(targetId);
				if (!target) {
					var target = document.createElement('textarea');
					target.style.position = 'absolute';
					target.style.left = '-9999px';
					target.style.top = '0';
					target.id = targetId;
					document.body.appendChild(target);
				}
				target.textContent = elem.textContent;
			}
			// select the content
			var currentFocus = document.activeElement;
			target.focus();
			target.setSelectionRange(0, target.value.length);

			// copy the selection
			var succeed;
			try {
				succeed = document.execCommand('copy');
			} catch (e) {
				succeed = false;
			}
			// restore original focus
			if (currentFocus && typeof currentFocus.focus === 'function') {
				currentFocus.focus();
			}

			if (isInput) {
				// restore prior selection
				elem.setSelectionRange(origSelectionStart, origSelectionEnd);
			} else {
				// clear temporary content
				target.textContent = '';
			}

			document.getElementById('copyClipboardButton').focus();
			
			return succeed;
		}

		function closeNoaAlreadyExistsModal() {
			scope.showNoaAlreadyExistsModal = false;
		}
	}
})();
